import type { AssistedAffiliationDraftObservation } from "@/services/assistedAffiliation/types";
import { formatCreatedAt } from "./constants";
import type { RequestHistoryRow } from "./types";

// El cambio más reciente arriba. Es el único valor que cambia si se prefiere el orden inverso.
export const HISTORY_NEWEST_FIRST = true;

const EMPTY_CELL = "-";

const toTime = (value?: string): number | null => {
  if (!value) return null;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? null : time;
};

/**
 * Convierte las notas que trae la consulta en filas del historial, ordenadas por fecha.
 *
 * El servicio las devuelve de la más antigua a la más reciente, pero las de un mismo guardado comparten
 * la misma hora: en un empate se respeta el orden en que llegaron (invertido si va lo más reciente
 * arriba). Hoy ese es el orden en que se guardaron, aunque el servicio no lo garantiza: ordena solo por
 * la hora. Una nota sin fecha válida va al final.
 */
export const toHistoryRows = (
  observations: AssistedAffiliationDraftObservation[] = [],
  newestFirst: boolean = HISTORY_NEWEST_FIRST
): RequestHistoryRow[] => {
  const direction = newestFirst ? -1 : 1;

  return observations
    .map((observation, index) => ({ observation, index, time: toTime(observation.created_at) }))
    .sort((first, second) => {
      if (first.time !== second.time) {
        if (first.time === null) return 1;
        if (second.time === null) return -1;
        return (first.time - second.time) * direction;
      }
      return (first.index - second.index) * direction;
    })
    .map(({ observation, index }) => ({
      key: String(index),
      date: formatCreatedAt(observation.created_at ?? "") || EMPTY_CELL,
      status: observation.status,
      reason: observation.observation,
      user: observation.created_by || EMPTY_CELL,
    }));
};
